/**
 * @packageDocumentation
 * @module f1/array
 */

import { I } from '../core/immutable';

export interface Concat {
  /**
   * Concatenate the first array to the back of the second array
   *
   * @public
   * @function f1.concat
   * @param tail to concatenate to the tail of the array
   * @param arr the array at the beginning
   * @example
   *
   * ```ts
   * f1.concat([1, 2], [3]) => [3, 1, 2]
   * ```
   *
   */
  <T>(valSeq: T[], arr: T[]): T[];
  <T>(valSeq: T[]): (arr: T[]) => T[];
}

/**
 * @see Concat
 */
export default <T>(tail: T[], arr: T[]): T[] => {
  // @note `concat` is twice as fast as the spread operator
  return I.array(arr).concat(tail || []);
};
